export default "__VITE_ASSET__B1Pw_Xjy__"